export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Probíhá"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dokončeno"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Čeká"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Další"])}
}